import React from 'react';
import { Badge } from '@/components/ui';
import type { ProgressLogStatus } from '../types/construction-progress.types';

interface Props {
  status: ProgressLogStatus;
  className?: string;
}

const statusConfig: Record<ProgressLogStatus, { label: string; color: string }> = {
  draft: { label: 'Bản thảo', color: 'bg-slate-100 text-slate-600' },
  submitted: { label: 'Đã gửi', color: 'bg-blue-100 text-blue-600' },
  reviewing: { label: 'Đang soát xét', color: 'bg-amber-100 text-amber-600' },
  approved: { label: 'Đã duyệt', color: 'bg-emerald-100 text-emerald-600' },
  rejected: { label: 'Từ chối', color: 'bg-red-100 text-red-600' },
  qa_pending: { label: 'Chờ QA', color: 'bg-indigo-100 text-indigo-600' },
  qa_failed: { label: 'QA không đạt', color: 'bg-rose-100 text-rose-600' },
  closed: { label: 'Đã đóng', color: 'bg-slate-900 text-white' },
};

export const ProgressStatusBadge: React.FC<Props> = ({ status, className }) => {
  const config = statusConfig[status] || { label: status, color: 'bg-slate-100 text-slate-600' };
  
  return (
    <Badge className={`${config.color} border-transparent text-[10px] font-bold ${className}`}>
      {config.label}
    </Badge>
  );
};
